module.exports = __webpack_public_path__ + "img/imp.e161cdd3.svg";